export default {
  SIGNIN_REQUEST: 'SIGNIN_REQUEST',
  SIGNIN_SUCCESS: 'SIGNIN_SUCCESS',
  SIGNIN_FAILURE: 'SIGNIN_FAILURE',

  VERIFY_SIGNIN_REQUEST: 'VERIFY_SIGNIN_REQUEST',
  VERIFY_SIGNIN_SUCCESS: 'VERIFY_SIGNIN_SUCCESS',
  VERIFY_SIGNIN_FAILURE: 'VERIFY_SIGNIN_FAILURE',

  SIGNOUT_REQUEST: 'SIGNOUT_REQUEST',
  SIGNOUT_SUCCESS: 'SIGNOUT_SUCCESS',
  SIGNOUT_FAILURE: 'SIGNOUT_FAILURE',

  CHANGE_HOSPITAL_REQUEST: "CHANGE_HOSPITAL_REQUEST",
  CHANGE_HOSPITAL_SUCCESS: "CHANGE_HOSPITAL_SUCCESS",
  CHANGE_HOSPITAL_FAILURE: "CHANGE_HOSPITAL_FAILURE",
};